import LazyLoader from './lazyLoader';

export const loader = new LazyLoader();
